import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	Button,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	FormInput,
	FormMultiSelect,
	Loader,
	Text,
	TextButton,
	units,
} from '@calm-web/design-system';

export const FormInputStyled = styled(FormInput).attrs({
	borderRadius: '100px',
	borderColor: 'gray3',
	iconColor: 'gray3',
})`
	max-width: ${units(86)};
`;

export const RegularText = styled(Text).attrs({
	size: FontSizes.base,
})``;

export const ClearLink = styled(TextButton)`
	color: ${palette('adaptiveText', 'white')};
	${fontSize(FontSizes.sm)};
	${fontWeight(FontWeights.Medium)};
	white-space: nowrap;
	margin-left: ${units(1)};
	text-decoration: none;
`;

export const SearchInputContainer = styled.div`
	display: flex;
	width: 100%;
`;

export const CategoryAndDurationContainer = styled.div`
	display: flex;
	gap: ${units(0.5)};
`;

export const SearchSubmitButton = styled(Button).attrs({
	type: 'submit',
	textColor: 'gray7',
})``;

export const StyledFormMultiSelect = styled(FormMultiSelect).attrs({
	size: 'sm',
	tooltipTextSize: FontSizes.sm,
	borderColor: 'gray3',
	downArrowColor: 'gray3',
})``;

export const SearchContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	${SearchInputContainer} {
		margin-bottom: ${units(1.5)};
	}
	${SearchSubmitButton} {
		line-height: normal;
	}
`;

export const SearchStyledLoader = styled(Loader)`
	circle {
		fill: ${palette('adaptiveText', 'white')};
	}
`;

export const Form = styled.form`
	width: 100%;
`;
